import { render, staticRenderFns } from "./DetailAndroid.vue?vue&type=template&id=18cc5942&scoped=true&"
import script from "./DetailAndroid.vue?vue&type=script&lang=ts&"
export * from "./DetailAndroid.vue?vue&type=script&lang=ts&"
import style0 from "./DetailAndroid.vue?vue&type=style&index=0&id=18cc5942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc5942",
  null
  
)

export default component.exports